import i18n from '@/i18n';

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

// テキスト入力のチェック
export function checkStringInput(value) {
    // 入力がされていない場合
    if (!value.trim()) {
        return t('errors.input_required');
    }

    // 文字数制限
    if (value.length > 20) {
        return t('errors.input_length_limit_20');
    }

    // 文字種制限（例: 半角英数字のみ許可）
    if (!/^[a-zA-Z0-9]+$/.test(value)) {
    // if (!/^[a-zA-Z0-9 -/:-@[-`{-~]+$/.test(value)) {
        return t('errors.alphanumeric_only');
    }

    return '';
}

// 数字入力のチェック
export function checkNumberInput(value) {
    // 入力がされていない場合 入力なくともバリデーションは通過
    if (!value.trim()) {
        // return t('errors.input_required');
        return '';
    }

    // 文字数制限
    if (value.length > 3) {
        return t('errors.valid_number_required');
    }

    // 文字種制限（例: 半角数字のみ許可）
    if (!/^[0-9]+$/.test(value)) {
        return t('errors.numeric_only');
    }

    // 年齢制限
    if (value < 0 || value > 150) {
        return t('errors.age_range');
    }

    return '';
}

export function checkPasswordInput(value) {
    // 入力がされていない場合
    if (!value.trim()) {
        return t('errors.input_required');
    }

    // 文字種制限（例: 半角数字のみ許可）
    const invalidCharactersRegex = /[^A-Za-z0-9!#$%&()*+,-./:;<=>?@[\]^_`{|}~]+/;
    if (invalidCharactersRegex.test(value)) {
        return t('errors.password_chars_allowed');
    }

    // 文字数制限
    if (value.length > 30) {
        return t('errors.input_length_limit_30');
    }

    return '';
}

export function checkNameInput(value) {
  // 入力がされていない場合 入力なくともバリデーションは通過
  if (!value.trim()) {
    return '';
  }

  // 文字数制限
  if (value.length > 30) {
    return t('errors.input_length_limit_30');
  }

  return '';
}
